module.exports = __webpack_public_path__ + "img/Julia2.0083c0f2.png";